import { render, staticRenderFns } from "./my-team.vue?vue&type=template&id=34199881&scoped=true&"
import script from "./my-team.vue?vue&type=script&lang=ts&"
export * from "./my-team.vue?vue&type=script&lang=ts&"
import style0 from "./my-team.vue?vue&type=style&index=0&id=34199881&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34199881",
  null
  
)

export default component.exports